module.exports = __webpack_public_path__ + "static/HackTheBox-4ccbb2060e0190dc5c6120f5f7b244cf.png";